import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { MAIN_SCREEN } from '../../../constant'
import classes from '../index.module.scss'
import { removeMainScreenPanel, selectCount } from '../store/slice'
import { ConfirmDeletePanel } from './popup/ConfirmDeletePanel'

const RemoveMainScreen = () => {
  const dispatch = useDispatch()

  const [typeDelete, setTypeDelete] = useState(null)

  const countC = useSelector(selectCount(MAIN_SCREEN.COMPANY_ANALYSIS)) || 0
  const countP = useSelector(selectCount(MAIN_SCREEN.PORTFOLIO_INSIGHT)) || 0

  const removePanels = (mainScreen) => {
    dispatch(removeMainScreenPanel(mainScreen))
  }

  const getElement = (children) => {
    const isLargeScreen = window.innerWidth >= 1135
    return (
      <Element elementName={isLargeScreen ? 'div' : 'span'}>{children}</Element>
    )
  }

  const actionDeleteC = () => {
    if (!countC) return
    setTypeDelete(MAIN_SCREEN.COMPANY_ANALYSIS)
  }

  const actionDeleteP = () => {
    if (!countP) return
    setTypeDelete(MAIN_SCREEN.PORTFOLIO_INSIGHT)
  }

  const onClosePopupDelete = () => {
    setTypeDelete(null)
  }

  const onSubmitDelete = () => {
    if (typeDelete === MAIN_SCREEN.COMPANY_ANALYSIS) {
      removePanels(MAIN_SCREEN.COMPANY_ANALYSIS)
    }
    if (typeDelete === MAIN_SCREEN.PORTFOLIO_INSIGHT) {
      removePanels(MAIN_SCREEN.PORTFOLIO_INSIGHT)
    }

    setTypeDelete(null)
  }

  return (
    <div className={`dFlex justifyContentBetween ${classes.mt4}`}>
      <Element
        style={{ backgroundColor: '#EDF5FE', color: '#2C73E8' }}
        className={classes.removeMainScreen}
        onClick={actionDeleteC}
      >
        {getElement(<Translate value="dynamicReport.REMOVE_C_PANELS" />)}
        {getElement(<>({countC})</>)}
      </Element>
      <Element
        style={{ backgroundColor: '#EDF5FE', color: '#2C73E8' }}
        className={classes.removeMainScreen}
        onClick={actionDeleteP}
      >
        {getElement(<Translate value="dynamicReport.REMOVE_P_PANELS" />)}
        {getElement(<>({countP})</>)}
      </Element>
      {!!typeDelete && (
        <ConfirmDeletePanel
          isShow={!!typeDelete}
          handleClose={onClosePopupDelete}
          handleSubmit={onSubmitDelete}
        />
      )}
    </div>
  )
}

export default RemoveMainScreen
